<template>
    <el-dialog title="Detalle de la notificación"
        :visible="showDialogDetail"
        @open="loadHistoryDetails"
        @close="close"
        append-to-body
    >
        <div class="row">
            <div class="col-12" v-loading="loading">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Usuario</th>
                                <th>Perfil</th>
                                <th class="text-center">Tipo <br>Dispositivo</th>
                                <th class="text-center">Estado de notificación</th>
                                <th class="text-center">Fecha leida</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="detail in details">
                                <td>
                                    {{ detail.user }}
                                </td>
                                <td>
                                    {{ detail.profile }}
                                </td>
                                <td class="text-center">
                                    <span>Web</span>
                                    <br>
                                    <span>Aplicativo</span>
                                </td>
                                <td class="text-center">
                                    <el-tag
                                        :type="detail.read ? 'primary' : 'warning'"
                                        size="mini"
                                    >
                                        {{ detail.read ? 'Leida' : 'No leida' }}
                                    </el-tag>
                                    <br>
                                    <el-tag
                                        :type="detail.read_mobile ? 'primary' : 'warning'"
                                        size="mini"
                                    >
                                        {{ detail.read_mobile ? 'Leida' : 'No leida' }}
                                    </el-tag>
                                </td>
                                <td class="text-center">
                                    <span>
                                        {{ detail.read_at ? detail.read_at : '-' }}
                                    </span>
                                    <br>
                                    <span>
                                        {{ detail.read_mobile_at ? detail.read_mobile_at : '-' }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: 'HistoryDetails',
        props: {
            showDialogDetail: {
                type: Boolean,
                default: false
            },
            dataHistory: {
                type: Object,
                default: () => ({})
            },
            systemId: {
                type: [String, Number],
                default: null
            }
        },
        data() {
            return {
                loading: false,
                details: []
            }
        },
        methods: {
            close() {
                this.$emit('update:showDialogDetail', false)
                this.details = []
            },

            async loadHistoryDetails() {
                try {
                    this.loading = true
                    const { data } = await this.$http.get(`/notifications/getHistoryDetails/${this.systemId}/${this.dataHistory.id}`)
                    if (data.success) {
                        this.details = data.data
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    
                } finally {
                    this.loading = false
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/notifications/partials/HistoryDetails.vue